import React from "react";
import { Loader2 } from "lucide-react";

export const Loading = ({ label = "Loading", className = "" }) => (
  <div className={`flex min-h-[200px] w-full items-center justify-center ${className}`}>
    <div className="flex flex-col items-center gap-3 text-muted-foreground">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <span className="text-sm">{label}…</span>
    </div>
  </div>
);

export const FullPageLoading = () => (
  <div className="flex min-h-screen w-full items-center justify-center bg-background">
    <Loader2 className="h-7 w-7 animate-spin text-primary" />
  </div>
);

export const EmptyState = ({ icon: Icon, title, description, action, testId }) => (
  <div
    className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-card p-10 text-center"
    data-testid={testId}
  >
    {Icon && (
      <div className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-full bg-secondary">
        <Icon className="h-6 w-6 text-muted-foreground" />
      </div>
    )}
    <h3 className="text-base font-[620] text-foreground">{title}</h3>
    {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
